import { render, staticRenderFns } from "./edit-exportprofit.vue?vue&type=template&id=5884e7d7"
import script from "./edit-exportprofit.vue?vue&type=script&lang=ts"
export * from "./edit-exportprofit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports